import React, { PureComponent } from "react";

class Sound extends PureComponent {
  state = {
    isPlaying: false
  };

  play(e) {
    const { src } = this.props;
    e.preventDefault();

    this.setState({
      isPlaying: true
    });

    const sound = new Audio(src);
    sound.addEventListener(
      "ended",
      () => {
        this.setState({
          isPlaying: false
        });
      },
      false
    );
    sound.play();
  }

  render() {
    const { an, wv } = this.props;
    const { isPlaying } = this.state;

    return (
      <a
        href="#play"
        className={isPlaying ? "playing" : null}
        onClick={e => this.play(e)}
      >
        {isPlaying ? wv : an}
      </a>
    );
  }
}

export default Sound;



// WEBPACK FOOTER //
// ./src/components/Sound.js